<h1 i18n>Processing...</h1>
<p i18n>You are seeing this page because you were redirected from Salesforce (Deep linking integration).</p>
<p i18n>Please be patient, Finishline is processing your request.</p>

<div class="spinner-wrapper">
  <mat-spinner diameter="50" ></mat-spinner>
</div>